module.exports = __webpack_public_path__ + "img/16.ef2c9dae.png";